function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.41026 18.5013C9.45385 18.5013 10.3077 17.6475 10.3077 16.6039H6.51282C6.51282 17.6518 7.36233 18.5013 8.41026 18.5013ZM14.1024 12.809V8.06544C14.1024 5.15288 12.5465 2.71468 9.83313 2.06955V1.42442C9.83313 0.636984 9.19749 0.00134277 8.41006 0.00134277C7.62262 0.00134277 6.98698 0.636984 6.98698 1.42442V2.06955C4.26416 2.71468 2.71775 5.14339 2.71775 8.06544V12.809L0.820312 14.7065V15.6552H15.9998V14.7065L14.1024 12.809Z",
  fill: "#23335B"
});

var SvgBellFill = function SvgBellFill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBellFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bell-fill.16eca627.svg";
export { ForwardRef as ReactComponent };